import React from 'react';

const DO = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_163"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_163)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#002B64"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9H9V15H0V9ZM12 0H21V6H12V0Z"
        fill="#D0091E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 9H0V6H9V0H12V6H21V9H12V15H9V9Z"
        fill="white"
      />
      <path
        d="M10.5 9C11.3284 9 12 8.32843 12 7.5C12 6.67157 11.3284 6 10.5 6C9.67157 6 9 6.67157 9 7.5C9 8.32843 9.67157 9 10.5 9Z"
        fill="#007A1B"
      />
      <path
        d="M10.5 8C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7C10.2239 7 10 7.22386 10 7.5C10 7.77614 10.2239 8 10.5 8Z"
        fill="#002B64"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 7C9.776 7 10 6.776 10 6.5C10 6.224 9.776 6 9.5 6C9.224 6 9 6.224 9 6.5C9 6.776 9.224 7 9.5 7ZM11.5 7C11.776 7 12 6.776 12 6.5C12 6.224 11.776 6 11.5 6C11.224 6 11 6.224 11 6.5C11 6.776 11.224 7 11.5 7Z"
        fill="#FDD200"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default DO;
